import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import { myInternshipHistoryList } from "../user.api";
import moment from "moment";
import { useHistory } from "react-router-dom";
import BreadCrumpBack from "../../../components/navigator/back";
import "./style.css";

export default function RegisteredInternshipsHistory(props) {
  const history = useHistory();
  const [historyData, setHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = () => {
    setIsLoading(true);
    myInternshipHistoryList()
      .then((res) => {
        if (res?.success) {
          setHistoryData(res.data || []);
        } else {
          setSnackMessage("Failed to load internship history");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching history:", error);
        setSnackMessage("Error loading internship history");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const getBaseUrl = () => {
    const baseUrl = process?.env?.REACT_APP_BASE_URL || "http://127.0.0.1:8000/";
    return baseUrl.replace(/\/api\/?$/, "");
  };

  const resolvePath = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const cleanBase = getBaseUrl().replace(/\/$/, "");
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${cleanBase}${cleanPath}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'certified': return '#28a745';
      case 'absorbed': return '#6f42c1';
      case 'evaluated': return '#007bff';
      default: return '#6c757d';
    }
  };

  return (
    <div className="registered-internships-page">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="dash-banner">
        <div className="tit-txt">
          {props.state.language === "ma" ? "ഇന്റേൺഷിപ്പ് ഹിസ്റ്ററി" : "Internship History"}
        </div>
      </div>

      <BreadCrumpBack />

      <div className="container p-50">
        {/* <div className="d-flex justify-content-between align-items-center mb-5">
          <h5 className="fw-bold text-dark">
            {props.state.language === "ma" ? "കഴിഞ്ഞകാല ഇന്റേൺഷിപ്പുകൾ" : "Past Internships"}
          </h5>
        </div> */}

        {historyData && historyData.length > 0 ? (
          <div className="row">
            {historyData.map((item, index) => (
              <div key={index} className="col-lg-6 mb-4">
                <div className="card internship-history-card shadow-sm border-0 h-100" style={{ borderLeft: `6px solid ${getStatusColor(item.status)}` }}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h4 className="h5 mb-1 fw-bold text-dark">
                          {item.internship_request?.internship_discipline || "Internship Program"}
                        </h4>
                        <div className="text-muted small">
                          {item.internship_request?.company?.company_name || "Company Details N/A"}
                        </div>
                      </div>
                      <span className="badge rounded-pill" style={{ backgroundColor: getStatusColor(item.status), color: '#fff' }}>
                        {item.status?.toUpperCase()}
                      </span>
                    </div>

                    <div className="row g-3 mb-4">
                      <div className="col-sm-6">
                        <div className="history-meta-item">
                          <label className="text-muted d-block small mb-1">Duration</label>
                          <span className="fw-bold small">
                            {moment(item.start_date).format("DD MMM YYYY")} - {moment(item.completion_date).format("DD MMM YYYY")}
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="history-meta-item">
                          <label className="text-muted d-block small mb-1">Preference Order</label>
                          <span className="fw-bold small">#{item.preference_order}</span>
                        </div>
                      </div>
                      {/* {item.evaluation_remarks && (
                        <div className="col-12">
                          <div className="history-meta-item bg-light p-2 rounded">
                            <label className="text-muted d-block small mb-1">Remarks</label>
                            <p className="small mb-0 text-dark fst-italic">"{item.evaluation_remarks}"</p>
                          </div>
                        </div>
                      )} */}
                    </div>
                    <div className="d-flex gap-2">
                      {item.joint_certificate_url || item.joint_certificate ? (
                        <a
                          href={resolvePath(item.joint_certificate_url || item.joint_certificate)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-success w-100 d-flex align-items-center justify-content-center"
                        >
                          <i className="fa fa-certificate me-2"></i>
                          Download Certificate
                        </a>
                      ) : (
                        <button className="btn btn-sm btn-light w-100" disabled>
                          Certificate Pending
                        </button>
                      )}

                      {/* {item.evaluation_report_file_url && (
                        <a
                          href={item.evaluation_report_file_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary"
                          title="Evaluation Report"
                        >
                          <i className="fa fa-file-pdf"></i>
                        </a>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5 bg-white rounded-4 border border-light">
            <img src="/assets/img/empty-in.svg" alt="Empty" style={{ maxWidth: '120px' }} className="mb-3 opacity-25" />
            <p className="text-muted small">
              {props.state.language === "ma" ? "ചരിത്രം ഒന്നും കണ്ടുകിട്ടിയില്ല" : "No internship history found"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
